import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { useVirtualCoachingFlag } from './use-virtual-coaching'

// Runs the query that selects the Virtual Coaching fields when the feature
// flag is on, so a coach who lost Coach+ still sees the virtual offerings they
// own. When the API returns no data for it (the schema does not expose those
// fields yet, or the request failed), falls back to the original query so the
// existing screens keep working, and reports the fallback to Raygun.
export const useVirtualCoachingQuery = (
  query,
  virtualCoachingQuery,
  options,
) => {
  const flagEnabled = useVirtualCoachingFlag()
  const virtualCoachingResult = useQuery(virtualCoachingQuery, {
    ...options,
    skip: !flagEnabled,
  })

  const virtualCoachingFailed =
    flagEnabled && !virtualCoachingResult.loading && !virtualCoachingResult.data
  const useVirtualCoachingResult = flagEnabled && !virtualCoachingFailed
  const result = useQuery(query, {
    ...options,
    skip: useVirtualCoachingResult,
  })

  useEffect(() => {
    if (!virtualCoachingFailed) return
    window.rg4js &&
      window.rg4js('send', {
        error:
          virtualCoachingResult.error ||
          new Error('Virtual Coaching query returned no data'),
        tags: ['virtual-coaching', 'query-fallback'],
      })
  }, [virtualCoachingFailed, virtualCoachingResult.error])

  return useVirtualCoachingResult ? virtualCoachingResult : result
}
